import { render, staticRenderFns } from "./RiepilogoOspiti.vue?vue&type=template&id=9f2d64ea"
import script from "./RiepilogoOspiti.vue?vue&type=script&lang=js"
export * from "./RiepilogoOspiti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports